var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CodeBlock, CodeBlockCode, Flex, FlexItem, Text, TextVariants } from '@patternfly/react-core';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';
export const LogSnippetBorderVariant = {
    danger: 'danger',
    success: 'success',
    info: 'info',
    warning: 'warning'
};
const useStyles = createUseStyles({
    logSnippet: {
        marginLeft: 'var(--pf-v5-global--spacer--sm)',
        padding: 'var(--pf-v5-global--spacer--sm) 0 var(--pf-v5-global--spacer--sm) var(--pf-v5-global--spacer--sm)',
        backgroundColor: 'var(--pf-v5-global--BackgroundColor--100)',
    },
    variantBorderColor: (leftBorderVariant) => ({
        borderLeft: `var(--pf-v5-global--BorderWidth--md) solid var(--pf-v5-global--${leftBorderVariant}-color--100)`,
    }),
    statusMessage: {
        marginBottom: 'var(--pf-v5-global--spacer--sm)',
    },
});
export const LogSnippet = (_a) => {
    var { logSnippet, message, leftBorderVariant = LogSnippetBorderVariant.danger, ouiaId = "LogSnippet" } = _a, props = __rest(_a, ["logSnippet", "message", "leftBorderVariant", "ouiaId"]);
    const classes = useStyles(leftBorderVariant);
    return (React.createElement(Flex, Object.assign({ direction: { default: 'column' }, className: clsx(classes.logSnippet, classes.variantBorderColor), "data-ouia-component-id": ouiaId }, props),
        React.createElement(FlexItem, null, typeof message === 'string' ? React.createElement(Text, { component: TextVariants.p, className: classes.statusMessage, "data-ouia-component-id": `${ouiaId}-message` }, message) : message),
        logSnippet && React.createElement(FlexItem, null,
            React.createElement(CodeBlock, { "data-ouia-component-id": `${ouiaId}-code-block` },
                React.createElement(CodeBlockCode, { "data-ouia-component-id": `${ouiaId}-code-content` }, logSnippet)))));
};
export default LogSnippet;
